import { useContext } from 'react';

import { AdaptiveContext } from '../components/adaptive-provider';

export const useAdaptive = () => useContext(AdaptiveContext);
